import { render } from "./ModalDiagnosticarMasivo.vue?vue&type=template&id=f28665f4&scoped=true"
import script from "./ModalDiagnosticarMasivo.vue?vue&type=script&lang=js"
export * from "./ModalDiagnosticarMasivo.vue?vue&type=script&lang=js"

import "./ModalDiagnosticarMasivo.vue?vue&type=style&index=0&id=f28665f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28665f4"]])

export default __exports__